import { User, UserToUpdate } from "@/interfaces/User";
import _userService from "@/services/user";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getUser = createAsyncThunk("user/getUser", async () => {
  const user = await _userService.getUser();
  return user;
});

export const allUsers = createAsyncThunk("user/allUsers", async () => {
  const users = await _userService.allUsers();
  return users;
});

export const updateSelf = createAsyncThunk(
  "user/updateSelf",
  async (user: Partial<User>) => {
    const updatedUser = await _userService.updateSelf(user);
    return updatedUser;
  },
);

export const createUser = createAsyncThunk(
  "user/createUser",
  async (user: Partial<User>): Promise<string> => {
    const createdUser = await _userService.createUser(user);
    return createdUser;
  },
);

export const updateSubscriptions = createAsyncThunk(
  "user/updateSubscriptions",
  async ({
    user,
    userId,
  }: {
    user: Partial<UserToUpdate>;
    userId: string;
  }): Promise<string> => {
    const createdUser = await _userService.updateSubscriptions(user, userId);
    return createdUser;
  },
);

export const updateUser = createAsyncThunk(
  "user/updateUser",
  async ({
    user,
    userId,
  }: {
    user: Partial<User>;
    userId: string;
  }): Promise<string> => {
    const updatedUser = await _userService.updateUser(user, userId);
    return updatedUser;
  },
);

export const deleteUser = createAsyncThunk(
  "user/deleteUser",
  async (userId: string): Promise<string> => {
    const deletedUser = await _userService.deleteUser(userId);
    return deletedUser;
  },
);

export const restorePassword = createAsyncThunk(
  "user/restorePassword",
  async ({
    password,
    token,
  }: {
    password: string;
    token: string;
  }): Promise<{ message: string }> => {
    const response = await _userService.restorePassword(password, token);
    return response;
  },
);
